import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import DownloadIcon from '@mui/icons-material/Download';
import { useEffect, useState } from 'react';
import { BillingDetailsApi } from "../../utils/api/billingDetails";
import BillingNotification from './BillingNotification';

const BillingDetails: React.FC = () => {
    const [rows, setRow] = useState([]);

    useEffect(() => {
        const fetchBillingDetails = async () => {
            try {
                const response = await BillingDetailsApi.getBillingDetails();

                setRow(response);
            } catch (error) {
                console.error('Error fetching billing details:', error);
            }
        };

        fetchBillingDetails();
    }, [])

    
    const handleDownload = async (invoice: string) => {
        try {
            const response = await BillingDetailsApi.getInvoicePdf(invoice);

            // Create blob from the response data
            const blob = new Blob([response], { type: 'application/pdf' });

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = `invoice-${invoice}.pdf`;

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading invoice:', error);
        }
    };

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Subcription Type</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Invoice</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row: any, index) => (
                        <TableRow key={index}>
                            <TableCell>{row.month}</TableCell>
                            <TableCell>Monthly</TableCell> {/* All rows are monthly for now */}
                            <TableCell>{row.amount}</TableCell>

                            <TableCell>{row.status}</TableCell>
                            <TableCell>
                                {row.status === 'Paid' ? (
                                    <IconButton onClick={() => handleDownload(row.action)}>
                                        <DownloadIcon style={{ marginRight: '4px' }} />
                                    </IconButton>
                                ) : (
                                    <span className="col-danger" style={{ display: 'flex', alignItems: 'center' }}>
                                        <WarningIcon style={{ marginRight: '4px' }} />
                                        Pending
                                    </span>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <BillingNotification />
        </>
    );
};

export default BillingDetails;